import { createGlobalStyle } from 'styled-components';
import FontVTF323 from '../fonts/VT323-Regular.ttf';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'VT323';
    src: url(${FontVTF323});
  }

  :root {
    --dark-color-bg: rgb(7, 7, 7);
    --dark-color-primary: rgb(31, 248, 8);
    --dark-color-primary-transparent: rgba(31, 248, 8, 0.9);

    --light-color-primary: rgb(7, 7, 7);

    box-sizing: border-box;
    font-size: 16px;
    width: 100%;
    height: 100%;
    scroll-behavior: smooth;
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    background: var(--dark-color-bg);
    margin: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  #___gatsby {
    display: flex;
    height: 100%;
  }

  #gatsby-focus-wrapper {
    height: 100%;
    width: 100%;
  }

  a {
    text-decoration: none;
  }
`;
